import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { step2Schema } from "./schemas";
import step2DefaultValue from "./step2DefaultValue";

export type Step2FormData = yup.InferType<typeof step2Schema>;

export const useStep2Form = ({ defaultValues = step2DefaultValue } = {}) => {
  return useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(
      step2Schema.concat(
        yup.object({
          agreement: yup
            .bool()
            .oneOf(
              [true],
              "「利用規約」および「個人情報保護方針」に同意してください",
            ),
        }),
      ),
    ),
  });
};
